import api from '@/api'

const { $student, $academic } = api;

export const { $materias } = $student;

export const { $setting } = $academic